import type { CategoriaEvento, TipoEncontro, TipoPergunta } from './types';

export const CATEGORIAS: { valor: CategoriaEvento; rotulo: string }[] = [
  { valor: 'acampamento', rotulo: 'Acampamento' },
  { valor: 'retiro', rotulo: 'Retiro' },
  { valor: 'curso', rotulo: 'Curso' },
  { valor: 'encontro', rotulo: 'Encontro' },
  { valor: 'confraternizacao', rotulo: 'Confraternização' },
  { valor: 'quermesse', rotulo: 'Quermesse' },
  { valor: 'missa', rotulo: 'Missa / celebração' },
  { valor: 'congresso', rotulo: 'Congresso' },
  { valor: 'show', rotulo: 'Show' },
  { valor: 'formacao', rotulo: 'Formação' },
  { valor: 'rifa', rotulo: 'Ação entre amigos' },
  { valor: 'outro', rotulo: 'Outro' },
];

export const UFS = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
];

export const TIPOS_PERGUNTA: { valor: TipoPergunta; rotulo: string }[] = [
  { valor: 'texto_curto', rotulo: 'Resposta curta' },
  { valor: 'texto_longo', rotulo: 'Resposta longa' },
  { valor: 'sim_nao', rotulo: 'Sim ou não' },
  { valor: 'escolha_unica', rotulo: 'Escolher uma opção' },
  { valor: 'multipla_escolha', rotulo: 'Escolher várias' },
  { valor: 'numero', rotulo: 'Número' },
  { valor: 'data', rotulo: 'Data' },
  { valor: 'telefone', rotulo: 'Telefone' },
  { valor: 'email', rotulo: 'E-mail' },
  { valor: 'cpf', rotulo: 'CPF' },
  { valor: 'lista', rotulo: 'Lista' },
  { valor: 'foto', rotulo: 'Foto' },
];

export const TIPO_LABEL: Record<TipoPergunta, string> = TIPOS_PERGUNTA.reduce(
  (acc, t) => ({ ...acc, [t.valor]: t.rotulo }),
  {} as Record<TipoPergunta, string>,
);

export const TIPOS_COM_OPCOES: TipoPergunta[] = ['escolha_unica', 'multipla_escolha', 'lista'];

export const TIPOS_CONDICIONAVEIS: TipoPergunta[] = [
  'sim_nao',
  'escolha_unica',
  'multipla_escolha',
];

export const TIPOS_ENCONTRO: { valor: TipoEncontro; rotulo: string }[] = [
  { valor: 'formacao', rotulo: 'Formação' },
  { valor: 'vivencia', rotulo: 'Vivência' },
  { valor: 'missa', rotulo: 'Missa' },
  { valor: 'mutirao', rotulo: 'Mutirão' },
  { valor: 'reuniao', rotulo: 'Reunião' },
  { valor: 'encerramento', rotulo: 'Encerramento' },
  { valor: 'outro', rotulo: 'Outro' },
];